import type React from 'react';
import type { SavedListing } from 'app/shared/halo/contexts/SavedListingsContext';
import * as styles from './savedListingCard.styles';

type SavedListingCardProps = {
  listing: SavedListing;
  onRemove: (id: string) => void;
  onClick?: () => void;
};

export const SavedListingCard = ({ listing, onRemove, onClick }: SavedListingCardProps) => {
  const formatPrice = (amount: number): string => {
    return `$${amount.toLocaleString('en-US')}/mo`;
  };

  const buildDetailsText = (): string => {
    const parts: Array<string> = [];
    if (listing.bedDisplay) parts.push(listing.bedDisplay);
    if (listing.bathDisplay) parts.push(listing.bathDisplay);
    if (listing.neighborhood) parts.push(listing.neighborhood);
    return parts.join(' \u2022 ');
  };

  const handleRemove = () => {
    onRemove(listing.id);
  };

  const handleClick = (e: React.MouseEvent) => {
    if (!onClick) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    onClick();
  };

  return (
    <div className={styles.cardContainer}>
      <a
        href={listing.href || undefined}
        className={styles.cardContent}
        onClick={handleClick}
        aria-label={`View details for ${listing.title}`}
      >
        <img src={listing.imageUrl} alt="" className={styles.cardImage} />
        <div className={styles.cardInfo}>
          <div className={styles.cardTitlePriceContainer}>
            <h3 className={styles.cardTitle}>{listing.title}</h3>
            <div className={styles.cardPrice}>{formatPrice(listing.price)}</div>
          </div>
          <div className={styles.cardDetails}>{buildDetailsText()}</div>
          {listing.topAmenities && listing.topAmenities.length > 0 && (
            <div className={styles.amenitiesContainer}>
              {listing.topAmenities.slice(0, 2).map((amenity) => (
                <span key={amenity} className={styles.amenityPill}>
                  {amenity}
                </span>
              ))}
            </div>
          )}
        </div>
      </a>
      <button
        className={styles.removeButton}
        onClick={handleRemove}
        aria-label={`Remove ${listing.title} from saved listings`}
        type="button"
      >
        Remove
      </button>
    </div>
  );
};
